define([
    "dojo/_base/declare",
    "./MarkForDeletionCustomAttribute"
], function(declare,MarkForDeletionCustomAttribute) {

    return declare(MarkForDeletionCustomAttribute, {
        bMarkForDeletion: false
    });
});